import { useContext, useEffect, useRef } from 'react';
import axiosInstanceGenerator from '../../utils/axiosInstance';

import {
  apiSettingUpdatedDeliveryDate,
  apiExtendedDetail
} from '../../app_routes/settings';

import {
  SettingStateContext,
  SettingDispatchContext
} from '../../contexts/setting';

import { handleError } from '../../utils/errors';

import type { TSettingDetail } from '../../types/setting';

function DeliveryDate() {
  const { setting } = useContext(SettingStateContext);
  const { setSetting } = useContext(SettingDispatchContext);
  const settingDataRef = useRef(setting);
  const axios = axiosInstanceGenerator();
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();

  const sku = setting ? setting.vendor_sku : undefined;

  settingDataRef.current = setting;

  useEffect(() => {
    if (!sku) return;

    axios
      .get(apiSettingUpdatedDeliveryDate(sku), {
        cancelToken: source.token
      })
      .then(res => {
        setSetting({
          ...settingDataRef.current,
          delivery_date: res.data
        });
      })
      .catch(handleError);

    return () => {
      source.cancel('Unmounting');
    };
  }, [sku]);

  return null;
}

function ExtendedData() {
  const { setting } = useContext(SettingStateContext);
  const { setSetting } = useContext(SettingDispatchContext);
  const settingDataRef = useRef(setting);
  const axios = axiosInstanceGenerator();
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();

  const sku = setting ? setting.vendor_sku : undefined;

  settingDataRef.current = setting;

  useEffect(() => {
    if (!sku) return;

    axios
      .get(apiExtendedDetail(sku), {
        cancelToken: source.token
      })
      .then(res => {
        setSetting({
          ...settingDataRef.current,
          ...res.data
        });
      })
      .catch(handleError);

    return () => {
      source.cancel('Unmounting');
    };
  }, [sku]);

  return null;
}

function EngagementRing() {
  return [
    <DeliveryDate key='delivery-date' />,
    <ExtendedData key='extended-data' />
  ];
}

export default EngagementRing;
